import { commonMutationTypes, commonPaginationTypes, OrderDirection, pageInfo } from "../../../../../../utils/commonQueryTypes";

  
  export enum AtsStckManufacturerOrderField {
    CREATED_AT="CREATED_AT",
MANUFACTURER="MANUFACTURER",
SL_NO="SL_NO",
  }
  
  export interface GetStockManufacturersVars extends commonPaginationTypes {
    customer_id: number;
    orderBy: {
      direction: OrderDirection;
      field: AtsStckManufacturerOrderField;
    };
    name: string;
  }
  
  export interface AtsStckManufacturer {
    id: number;
    manufacturer: string;
    slNo: number;
    customerID: number;
  }
  
  export interface AtsStckManufacturerEdge {
    node: AtsStckManufacturer;
    cursor: string;
  }
  
  interface GetStockManufacturersData {
    edges: AtsStckManufacturerEdge[];
    pageInfo: pageInfo;
    totalCount: number;
  }
  
  export interface GetStockManufacturersResult {
    GetStockManufacturers: GetStockManufacturersData;
  }
  
  //Mutations
  
  
  
  export interface AddStockManufacturerVar extends commonMutationTypes {
    manufacturer: string;
    customer_id: number;
  }
  
  export interface AddStockManufacturerResult {
    AddStockManufacturer: boolean;
  }
  
  export interface UpdateStockManufacturerVar extends commonMutationTypes {
    manufacturer_id: number;
    manufacturer: string;
  }
  
  export interface UpdateStockManufacturerResult {
    UpdateStockManufacturer: boolean;
  }
  
  export interface DeleteManufacturerByIdResult {
    DeleteStockManufacturer:boolean
  }

  export interface DeleteManufacturerByIdVars extends commonMutationTypes{
    manufacturer_id:number
  }